import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CircularLoader from "../../../../../components/loader/CircularLoader";
import { get_Active_Categories_by_feature_slug } from "../../../../../DAL/blogs/BlogList";
import { useIds } from "../../../../../hook/AdminContext";
import { get_Active_podcast_Categories } from "../../../../../DAL/podcast/podcast";

export default function InsightsFilter({ inputs, setInputs }) {
  const { userInfo } = useIds();
  const [loading, setLoading] = useState(true);
  const { feature_slug, source_slug } = useParams();
  const [categoriesList, setCategories] = useState([]);

  const handleGetCategories = async () => {
    const resp =
      feature_slug == "leaders-in-the-industry"
        ? await get_Active_podcast_Categories(
            source_slug,
            feature_slug
          )
        : await get_Active_Categories_by_feature_slug(
            source_slug,
            feature_slug
          );
    if (resp.code == 200) {
      setCategories(resp.categories);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  const findObjectWithId = (id, list) => {
    return list.find((obj) => obj._id == id);
  };
  const handleChange = (e, list) => {
    const { name, value } = e.target;

    if (list) {
      let obj = findObjectWithId(value, list);
      setInputs((old) => ({ ...old, [name]: obj }));
    } else {
      setInputs((old) => ({ ...old, [name]: value }));
    }
  };

  useEffect(() => {
    handleGetCategories();
  }, []);

  if (loading) {
    return <CircularLoader height="150px" />;
  }

  return (
    <>
      {/* <FormControl fullWidth required>
        <InputLabel id={`sector-select-feature_type_Coaches_List`}>
          Insights List
        </InputLabel>
        <Select
          labelId={`sector-select-feature_type_Coaches_List`}
          id={`sector-select-feature_type_Coaches_List`}
          value={inputs?.list || "all"}
          required
          name="list"
          label={`Coaches List`}
          onChange={(e) => handleChange(e)}
        >
          <MenuItem key={"all"} value={"all"}>
            All Insights
          </MenuItem>
          <MenuItem key={"my-coaches"} value={userInfo._id}>
            My Insights
          </MenuItem>
        </Select>
      </FormControl> */}
      <h6>Select Category</h6>
      <FormControl fullWidth required className="mt-2">
        <InputLabel id={`sector-select-category`}>Category</InputLabel>
        <Select
          labelId={`sector-select-category`}
          id={`sector-select-category`}
          value={inputs?.category?._id || "all"}
          required
          name="category"
          label={`Category`}
          onChange={(e) => handleChange(e, categoriesList)}
        >
          <MenuItem key={"all"} value={"all"}>
            All Categories
          </MenuItem>
          {categoriesList.map((type) => (
            <MenuItem key={type._id} value={type._id}>
              {type.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
